import { PartialStoreState } from '../typings'

export const selectBreadcrumbTimeRange = (state: PartialStoreState) =>
  state.domain.publicData.breadcrumbTimeRange
